<search-dropdown  *ngIf="!disable" 
  [items]="locations" 
  [label]="'name'" 
  [uid]="'id'" 
  [placeholder]="_placeholder"
  (afterChange)="onChanged($event)"
  [(ngModel)]="locationId">
</search-dropdown>

<input *ngIf="disable" type="text" [(ngModel)]="location_Name" style="width:100%" class="form-control" [disabled]="true" />
